/**
 * 数字滑块组件（NumberSlider）
 */

import type { ReactElement } from 'react'
import { Slider } from '@/components/ui/slider'
import { cn } from '@/lib/utils'
import type { FormFieldProps } from './types'

/**
 * 数字滑块组件
 * @param props 组件属性
 * @returns 组件元素
 */
export function NumberSliderField({
  component,
  value,
  onChange,
  error,
  disabled = false,
}: FormFieldProps): ReactElement {
  const numValue = typeof value === 'number'
    ? value
    : typeof component.default_value === 'number'
      ? component.default_value
      : 0
  const config = component.config as { min?: number; max?: number; step?: number } | null
  const min = config?.min ?? 0
  const max = config?.max ?? 100
  const step = config?.step ?? 1

  /**
   * 处理滑块值变化
   * @param values 滑块值数组
   */
  function handleChange(values: number[]): void {
    onChange(values[0])
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">
          {component.title}
          {component.is_required && (
            <span className="ml-1 text-destructive">*</span>
          )}
        </label>
        <span className="text-sm font-medium text-primary">{numValue}</span>
      </div>
      <Slider
        value={[numValue]}
        onValueChange={handleChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        className={cn(
          'w-full',
          disabled && 'cursor-not-allowed opacity-50'
        )}
      />
      <div className="flex justify-between text-xs text-muted-foreground">
        <span>{min}</span>
        <span>{max}</span>
      </div>
      {error !== undefined && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  )
}
